(function () {
  var overlay, overlayRemoveTimeout, ageGate, ageGateMessage, ageGateControl;
  var AGE_GATE_LOCAL_STORAGE_KEY = "hasCheckedUserAge";

  function setStyle(element, style) {
    return Object.assign(element.style, style);
  }

  function storeToLocalStorage(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("Error saving to localStorage", error);
    }
  }

  function readFromLocalStorage(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      console.error("Error reading from localStorage", error);
    }
  }

  function checkUserAge() {
    var hasCheckedUserAge = readFromLocalStorage(AGE_GATE_LOCAL_STORAGE_KEY);

    if (!hasCheckedUserAge) renderUserAgeCheck();
  }

  function setScrollLock(shouldLock) {
    document.body.style.overflow = shouldLock ? "hidden" : "visible";
  }

  function setControlsState(isDisabled) {
    ageGateControl.forEach(function (control) {
      control.disabled = isDisabled;
    });
  }

  function renderUserAgeCheck() {
    setScrollLock(true);

    overlay.classList.toggle("is-visible", true);
    ageGate.classList.toggle("is-visible", true);

    ageGateControl.forEach(function (control) {
      control.addEventListener(
        "click",
        function (event) {
          var control = event.target.dataset.ageGateControl;
          var mapControlToHandler = {
            yes: renderUserAgeCheckSuccess,
            no: renderUserAgeCheckFailed,
          };
          var handler = mapControlToHandler[control];

          handler();
        },
        { once: true }
      );
    });
  }

  function renderUserAgeCheckFailed() {
    setControlsState(true);

    overlay.classList.toggle("is-locked", true);
    ageGateMessage.classList.toggle("is-visible", true);

    document.body.style.cursor = "not-allowed";
  }

  function renderUserAgeCheckSuccess() {
    setControlsState(true);

    clearTimeout(overlayRemoveTimeout);

    setScrollLock(false);

    ageGate.classList.toggle("is-visible", false);

    overlayRemoveTimeout = setTimeout(function () {
      overlay.classList.toggle("is-visible", false);
    }, 150);

    storeToLocalStorage(AGE_GATE_LOCAL_STORAGE_KEY, true);
  }

  function main() {
    var pageInfo = window.pageInfo;
    var shouldCheckUserAge =
      pageInfo.template === "collection" && pageInfo.handle === "all";

    overlay = document.querySelector("[data-page-overlay]");
    ageGate = document.querySelector("[data-age-gate]");
    ageGateMessage = document.querySelector("[data-age-gate-message]");
    ageGateControl = document.querySelectorAll("[data-age-gate-control]");

    if (shouldCheckUserAge) checkUserAge();
  }

  document.addEventListener("DOMContentLoaded", main, { once: true });
})();
